import QRCode from 'qrcode'
import { downloadPdf } from '../../../helpers/downloadPdf'
import CertificatePDF from './CertificatePDF'

export const certificateFileName = (certificate) => {
  const snapshot = certificate?.snapshot ?? {}
  const safe = (value) =>
    String(value ?? '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
  return `${[safe(snapshot.courseCode), safe(snapshot.courseTitle), 'certificate'].filter(Boolean).join('-')}.pdf`
}

// Builds and downloads the certificate PDF. `certificate` is the
// GET /training/certificates/:id response.
export const downloadCertificatePdf = async (certificate) => {
  const qrDataUrl = certificate.verifyUrl
    ? await QRCode.toDataURL(certificate.verifyUrl, { margin: 1, width: 336 })
    : undefined
  await downloadPdf(
    <CertificatePDF certificate={certificate} qrDataUrl={qrDataUrl} />,
    certificateFileName(certificate),
  )
}
